module.exports = __webpack_public_path__ + "static/media/twitter.d71808b3.png";